import React, { createContext, useContext, useEffect, useState } from 'react';
import { ChatService } from '../services/chatService';

const ChatContext = createContext(null);

export const ChatProvider = ({ children, user }) => {
  const [service, setService] = useState(null);
  const [, setActiveChatId] = useState(null);

  useEffect(() => {
    if (!user || (!user.id && !user._id)) return;
    const svc = new ChatService();
    svc.connect(user.id || user._id, user.role, user.token);

    // Global message listeners for notifications
    const unsub = svc.onMessage((msg) => {
      if (msg.senderId === (user.id || user._id)) return;
      // Suppress notification if user is actively on this specific chat (handled by activeChatId ref if needed, but we can do it via callback)
      // Note: we can't easily access the LATEST activeChatId here if we don't have it in deps,
      // but we can use a ref for activeChatId.
    });

    const unsubGroup = svc.onGroupMessage((msg) => {
      if (msg.senderId === (user.id || user._id)) return;
    });

    setService(svc);

    return () => {
      unsub();
      unsubGroup();
      svc.disconnect();
    };
  }, [user]);
  // Only recreate if user changes, NOT when switching chats.

  return (
    <ChatContext.Provider value={{ chatService: service, setActiveChatId }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatService = () => useContext(ChatContext);
